module.exports = __webpack_public_path__ + "static/img/home_lun2.50cc20d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_lun2.jpg
// module id = bL9/
// module chunks = 1